import { createSlice } from "@reduxjs/toolkit";

import {
  addClientIdPasswordManagerAction,
  addGstRegisterBusinessAction,
  addIdPasswordManagerAction,
  applyLeaveOrWHFAction,
  deleteIdPasswordManagerAction,
  deleteUpcomingLeave,
  editClientIdPasswordManagerAction,
  editIdPasswordManagerAction,
  getClientIdPasswordManagerListAction,
  getIdPasswordManagerListAction,
  getLeaveAndWFHListAction,
  getSingleLeaveAction,
  getTokenGenerateForDownloadAction,
  getUpcomingListAction,
  isGstRegisteredVerifyAction,
  leaveAndWFHApprovedStatusAction,
  leaveAndWFHRejectStatusAction,
  updateApplyLeaveOrWHFAction,
  uploadFilesAction,
  stcoToolsReducer,
  initialState,
} from "@/redux/stcoTools";
import type { StcoToolsType } from "@/redux/stcoTools/stcoToolsType";

export const stcoToolsSlice = createSlice({
  name: "stcoTools",
  initialState,
  reducers: stcoToolsReducer,

  extraReducers: (builder) => {
    builder.addCase(
      getIdPasswordManagerListAction.pending,
      (state: StcoToolsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getIdPasswordManagerListAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const { success, message, result, status_code, count } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
            getidPasswordManagerList: result,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          getidPasswordManagerList: result,
          totalUserCountList: count,
        };
      }
    );

    builder.addCase(
      getIdPasswordManagerListAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      addIdPasswordManagerAction.pending,
      (state: StcoToolsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addIdPasswordManagerAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const { success, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          message,
        };
      }
    );

    builder.addCase(
      addIdPasswordManagerAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      editIdPasswordManagerAction.pending,
      (state: StcoToolsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      editIdPasswordManagerAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          message,
        };
      }
    );

    builder.addCase(
      editIdPasswordManagerAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      deleteIdPasswordManagerAction.pending,
      (state: StcoToolsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteIdPasswordManagerAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          message,
        };
      }
    );

    builder.addCase(
      deleteIdPasswordManagerAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fetching: false,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getClientIdPasswordManagerListAction.pending,
      (state: StcoToolsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getClientIdPasswordManagerListAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const { data } = payload;
        const { success, message, result, status_code, count } = data;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
            getClientidPasswordManagerList: result,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          getClientidPasswordManagerList: result,
          totalClientList: count,
        };
      }
    );

    builder.addCase(
      getClientIdPasswordManagerListAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      addClientIdPasswordManagerAction.pending,
      (state: StcoToolsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addClientIdPasswordManagerAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const { success, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
        };
      }
    );

    builder.addCase(
      addClientIdPasswordManagerAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      editClientIdPasswordManagerAction.pending,
      (state: StcoToolsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      editClientIdPasswordManagerAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
            error: message,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
        };
      }
    );

    builder.addCase(
      editClientIdPasswordManagerAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getLeaveAndWFHListAction.pending,
      (state: StcoToolsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getLeaveAndWFHListAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const {
          success,
          message,
          result,
          status_code,
          count,
          total_count,
          leave_status,
        } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
            leaveAndWFHHistoryList: result,
            leaveTotalCount: total_count,
            balanceLeave: leave_status,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          leaveAndWFHHistoryList: result,
          leaveTotalCount: total_count,
          balanceLeave: leave_status,
        };
      }
    );

    builder.addCase(
      getLeaveAndWFHListAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(getUpcomingListAction.pending, (state: StcoToolsType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getUpcomingListAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const {
          success,
          message,
          result,
          status_code,
          count,
          leave_status,
          wfh_status,
        } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
            upcomingList: result,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          upcomingList: result,
          leaveStatus: leave_status,
          workFromHomeStatus: wfh_status,
        };
      }
    );

    builder.addCase(
      getUpcomingListAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(applyLeaveOrWHFAction.pending, (state: StcoToolsType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      applyLeaveOrWHFAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const { success, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          message,
        };
      }
    );

    builder.addCase(
      applyLeaveOrWHFAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(getSingleLeaveAction.pending, (state: StcoToolsType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getSingleLeaveAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const { success, message, result, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
            // singleLeaveAndWFHApplyData: result
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          singleLeaveAndWFHApplyData: result,
        };
      }
    );

    builder.addCase(
      getSingleLeaveAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      updateApplyLeaveOrWHFAction.pending,
      (state: StcoToolsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateApplyLeaveOrWHFAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const { success, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateApplyLeaveOrWHFAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(deleteUpcomingLeave.pending, (state: StcoToolsType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      deleteUpcomingLeave.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const { success, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          message,
        };
      }
    );

    builder.addCase(
      deleteUpcomingLeave.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      leaveAndWFHRejectStatusAction.pending,
      (state: StcoToolsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      leaveAndWFHRejectStatusAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const { success, message } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          message,
        };
      }
    );

    builder.addCase(
      leaveAndWFHRejectStatusAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      leaveAndWFHApprovedStatusAction.pending,
      (state: StcoToolsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      leaveAndWFHApprovedStatusAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          message,
        };
      }
    );

    builder.addCase(
      leaveAndWFHApprovedStatusAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      addGstRegisterBusinessAction.pending,
      (state: StcoToolsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addGstRegisterBusinessAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            gstRegisterSuccess: 0,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          gstRegisterSuccess: success,
          gstRegisterMessage: message,
        };
      }
    );

    builder.addCase(
      addGstRegisterBusinessAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        gstRegisterSuccess: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      isGstRegisteredVerifyAction.pending,
      (state: StcoToolsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      isGstRegisteredVerifyAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const { success, message, status_code, result } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success: 0,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          isGstRegisteredVerifyData: result,
        };
      }
    );

    builder.addCase(
      isGstRegisteredVerifyAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(uploadFilesAction.pending, (state: StcoToolsType) => ({
      ...state,
      fileUploadFetching: true,
    }));

    builder.addCase(
      uploadFilesAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const {
          success,
          message,
          result,
          status_code,
          fileUploadSuccess,
          fileUploadMessage,
        } = payload;
        if (success === 0) {
          return {
            ...state,
            fileUploadFetching: false,
            fileUploadError: message,
            statusCode: status_code,
            fileUploadData: payload.files,
            fileUploadSuccess,
          };
        }
        return {
          ...state,
          fileUploadFetching: false,
          fileUploadData: payload.files,
          fileUploadMessage,
          fileUploadSuccess,
        };
      }
    );

    builder.addCase(
      uploadFilesAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        fileUploadFetching: false,
        fileUploadError: error?.message ?? null,
        fileUploadSuccess: 0,
      })
    );

    builder.addCase(
      getTokenGenerateForDownloadAction.pending,
      (state: StcoToolsType) => ({
        ...state,
        sasTokenForDownloadFetching: true,
      })
    );

    builder.addCase(
      getTokenGenerateForDownloadAction.fulfilled,
      (state: StcoToolsType, { payload }) => {
        const {
          result = {},
          message,
          status_code,
          success,
          file_url,
        } = payload;
        if (success === 0) {
          return {
            ...state,
            sasTokenForDownloadFetching: false,
            error: message,
            success: 0,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          sasTokenForDownloadFetching: false,
          statusCode: status_code,
          sasTokenForDownloadFile: file_url,
        };
      }
    );

    builder.addCase(
      getTokenGenerateForDownloadAction.rejected,
      (state: StcoToolsType, { error }) => ({
        ...state,
        sasTokenForDownloadFetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );
  },
});

export const {
  resetIdPasswordManagerError,
  resetIdPasswordManagerSuccess,
  resetIdPasswordManagerList,
  resetIdPasswordManagerMessage,
  resetClientIdPasswordManagerList,
  resetIdPasswordManagerStatusCode,
  resetTotalUserCountList,
  resetTotalClientCountList,
  resetStcoToolsSuccess,
  resetStcoToolsError,
  resetStcoToolsMessage,
  resetStcoToolsStatusCode,
  resetUpcomingLeaveList,
  resetSingleLeaveAndWFHApplyData,
  resetLeaveAndWFHList,
  resetGstRegisterMessage,
  resetIsGstRegisteredVerifyData,
  resetGstRegisterSuccess,
  resetStcoToolsFetching,
  resetUploadedFiles,
  resetSasTokenForDownloadFile,
} = stcoToolsSlice.actions;
